
import * as moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Point } from '../../shared/contracts/AnswerContract';
import { IMemberWithoutBarometerHypermediaRepresentation } from '../../shared/contracts/MemberContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import MembersWithoutBarometerCollection from './MembersWithoutBarometerCollection.vue';
import PeopleActionCollection from './PeopleActionCollection.vue';

@Component({
    components: {
        PeopleActionCollection,
        MembersWithoutBarometerCollection
    }
})
export default class DashboardPeopleActions extends Vue {
    @Prop() snapshots: ISnapshotHypermediaRepresentation[];
    @Prop() totalNumberOfSnapshots: number;
    @Prop() membersWithoutBarometer: IMemberWithoutBarometerHypermediaRepresentation[];

    displayAllSnapshots: boolean = false;

    mounted() {
        this.$emit('updated');
    }

    get snapshotsToDisplay() {
        return this.displayAllSnapshots ? this.unexpiredSnapshots : this.snapshotsNeedingAction;
    }

    get membersWithoutBarometerToDisplay() {
      return this.displayAllSnapshots ? this.membersWithoutBarometer : null;
    }

    get snapshotsNeedingAction() {
        return this.unexpiredSnapshots.filter(snapshot =>
            snapshot.answers.some(
                answer => answer.quantitative === Point.Negative || answer.quantitative === Point.Neutral
            )
        );
    }

    get expiredSnapshots() {
        return this.snapshots.filter(snapshot => !this.isMaxSixMonthsAgo(snapshot.date));
    }

    get unexpiredSnapshots() {
        return this.snapshots.filter(snapshot => this.isMaxSixMonthsAgo(snapshot.date));
    }

    private isMaxSixMonthsAgo(date: string): boolean {
        const sixMonthsAgo = moment().subtract(6, 'months');
        return moment(date).isSameOrAfter(sixMonthsAgo, 'day');
    }
}
